import React from 'react';
import { cn } from '@/lib/utils';

interface AccountCircleProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

export const AccountCircle: React.FC<AccountCircleProps> = ({
  size = 32,
  width,
  height,
  fill = '#2E3E6F',
  className,
  ...props
}) => {
  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={w}
      height={h}
      fill={fill}
      className={cn('aspect-square', className)}
      role="img"
      aria-label="Account Circle"
      {...props}
    >
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
    </svg>
  );
};
